import { GenericBackendResponse } from '../../genericBackendResponse';

const toggleIndexaCapital = async (token: string): Promise<GenericBackendResponse<any>> => {
	try {
		const response = await fetch(
			`${process.env.REACT_APP_BASE_API}/thirdparty/indexa/token/toggle`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`
				}
			}
		);

		const responseData = await response.json();

		return responseData;
	} catch (error) {
		console.error('Error toggling Indexa Capital connection:', error);
		return {
			success: false,
			data: {},
			code: 500,
			responseAt: new Date().toISOString(),
			debugId: 'indexa-capital-toggle-error',
			message: 'Error al desconectar de Indexa Capital'
		};
	}
};

export default toggleIndexaCapital;
